import type { Contact } from '@taler/api-client'
import { compareInstant, type Locale } from '@taler/domain'

export const CONTACT_SORTS = ['name-asc', 'name-desc', 'since-newest', 'since-oldest'] as const
export type ContactSort = (typeof CONTACT_SORTS)[number]

function byName(locale: Locale, direction: 1 | -1) {
  return (a: Contact, b: Contact): number => direction * a.name.localeCompare(b.name, locale)
}

function bySince(direction: 1 | -1) {
  return (a: Contact, b: Contact): number => direction * compareInstant(a.createdAt, b.createdAt)
}

const COMPARATORS: Record<ContactSort, (locale: Locale) => (a: Contact, b: Contact) => number> = {
  'name-asc': (locale) => byName(locale, 1),
  'name-desc': (locale) => byName(locale, -1),
  'since-newest': () => bySince(-1),
  'since-oldest': () => bySince(1),
}

/** Contacts whose name contains the query (case-insensitive), in the requested order. */
export function visibleContacts(
  contacts: readonly Contact[],
  query: string,
  sort: ContactSort,
  locale: Locale,
): readonly Contact[] {
  const needle = query.trim().toLocaleLowerCase(locale)
  const matched =
    needle === '' ? contacts : contacts.filter((c) => c.name.toLocaleLowerCase(locale).includes(needle))
  return [...matched].sort(COMPARATORS[sort](locale))
}
